export enum DependencyTypeEnum {
    HasValue = "hasvalue",
    WithInRange = "withinrange",
    IsNotEmpty = "isnotempty",
    modelTarget = "model-target",
    DoesNotHaveValue = "doesnothavevalue",
    LimitOptions = "limit-options"
}
